import { Instance } from 'mobx-state-tree';
import { VisitDtoEdgeModelBase } from './VisitDtoEdgeModel.base';

/* The TypeScript type of an instance of VisitDtoEdgeModel */
export interface VisitDtoEdgeModelType extends Instance<typeof VisitDtoEdgeModel.Type> {}

/* A graphql query fragment builders for VisitDtoEdgeModel */
export { selectFromVisitDtoEdge, visitDtoEdgeModelPrimitives, VisitDtoEdgeModelSelector } from './VisitDtoEdgeModel.base';

/**
 * VisitDtoEdgeModel
 */
export const VisitDtoEdgeModel = VisitDtoEdgeModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
